import React, { useCallback, useEffect, useState } from 'react';
import { Text } from 'components/Base/Typography';
import { Colors, FontWeights } from 'core/CssVariables';
import { ETextLinkColors } from 'components/Base/TextLink';
import Button, { EButtonColors } from 'components/Base/Button';
import { Row } from 'components/Base/Grid';
import Countdown from 'components/Base/Countdown';
import { useResendSignUpAmplifyMutation } from 'redux/apiSlice/authAmplify.slice';
import { useAppSelector } from 'redux/store';
import { SCol } from './style';

const ResendVerificationCodeButton = () => {
  const { codeSend, username } = useAppSelector(
    state => state.authSlice.signInUser,
  ) || { username: '' };
  const [reFetch, { isLoading, isSuccess }] = useResendSignUpAmplifyMutation();
  const [time, setTime] = useState(0);

  useEffect(() => {
    if (codeSend || !username) {
      return;
    }
    reFetch({ username });
  }, []);

  useEffect(() => {
    if (!isSuccess) {
      return;
    }
    setTime(60);
  }, [isSuccess]);

  const handleResend = useCallback(() => {
    if (!username) {
      return;
    }
    reFetch({ username });
  }, [username]);

  return (
    <SCol>
      <Row justify="center">
        <Text
          fontLevel={4}
          color={Colors[ETextLinkColors.BLACK]}
          fontWeight={FontWeights.Regular}
        >
          Dont receive the code?
        </Text>
      </Row>
      <Row justify="center">
        {!time ? (
          <Button
            loading={isLoading}
            type="text"
            color={EButtonColors.Info}
            onClick={handleResend}
          >
            Resend the code
          </Button>
        ) : (
          <Text
            fontLevel={5}
            color={Colors[ETextLinkColors.BLACK]}
            fontWeight={400}
          >
            Resend the code in{' '}
            <Countdown
              className="countdown"
              sec={time}
              format="ss"
              onFinish={() => setTime(0)}
            />{' '}
            sec.
          </Text>
        )}
      </Row>
    </SCol>
  );
};

export default ResendVerificationCodeButton;
